<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navigation-example-2"
            @click="toggleNavbar"
          >
            <span class="sr-only">{{ $t("toggle_navigation") }}</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <span class="navbar-brand">{{ ws.getSetting("portal_name") }}</span>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <router-link :to="{ name: 'Home' }" tag="li">
              <a> <i class="fas fa-home"></i> {{ $t("dashboard") }} </a>
            </router-link>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div
        class="full-page login-page"
        data-color
        data-image="static/img/background/background-2.jpg"
      >
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <form method="#" action="#" @submit.prevent="doResetRequest">
                  <div class="card" data-background="color" data-color="blue">
                    <div class="card-header">
                      <h3 class="card-title">{{ $t("forgot_password") }}</h3>
                    </div>
                    <div class="card-content">
                      <div class="form-group">
                        <label>{{ $t("email_address") }}</label>
                        <input
                          type="email"
                          v-model="email"
                          :placeholder="$t('enter_email')"
                          class="form-control input-no-border"
                          v-validate="'required|email'"
                        />
                      </div>
                    </div>
                    <div class="card-footer text-center">
                      <router-link
                        :to="{ name: 'Login' }"
                        tag="button"
                        type="button"
                        class="btn btn-fill btn-wd"
                      >
                        <i class="fas fa-arrow-circle-left"></i>
                        {{ $t("back_to_login") }}
                      </router-link>
                      <button
                        type="submit"
                        :disabled="loading"
                        class="btn btn-fill btn-success btn-wd"
                      >
                        <i
                          class="fas"
                          :class="{
                            'fa-power-off': !loading,
                            'fa-atom fa-spin': loading,
                          }"
                        ></i>
                        {{ $t("request_reset") }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright"></div>
          </div>
        </footer>
        <div
          class="full-page-background"
          :style="{ backgroundImage: 'url(' + shuffledImage + ')' }"
          style="'background:no-repeat center center fixed;'"
        ></div>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link to="/register" tag="li">
          <a>{{ $t("register") }}</a>
        </router-link>
        <router-link to="/admin/overview" tag="li">
          <a>{{ $t("dashboard") }}</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vee-validate";
export default {
  computed: {
    ...mapFields(["email", "password", "password_repeat"]),
  },
  data() {
    return {
      email: "",
      shuffledImage: "",
      loading: false,
    };
  },
  mounted() {
    this.imageShuffler();
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    doResetRequest() {
      this.$validator.validateAll().then((result) => {
        this.loading = true;
        if (!result) {
        } else {
          Webservice.resetPasswordRequest(this.email)
            .then((resp) => {
              if (resp.data == "success") {
                this.$notify({
                  component: {
                    template:
                      "<span>" +
                      this.$t("request_sent_please_check_mailbox") +
                      "</span>",
                  },
                  icon: "fas fa-check",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "success",
                });
                this.$router.push({ name: "Login" });
              }
            })
            .catch((error) => {
              if (error.resp.data.errors) {
                this.loading = false;
                this.email = "";
                this.$notify({
                  component: {
                    template:
                      "<span>" +
                      $t("something_went_wrong_check_email") +
                      "</span>",
                  },
                  icon: "fas fa-exclamation-triangle",
                  horizontalAlign: "center",
                  verticalAlign: "top",
                  type: "warning",
                });
              }
            });
        }
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    imageShuffler() {
      var images = [
        "static/img/background/background-1.jpg",
        "static/img/background/background-2.jpg",
        "static/img/background/background-3.jpg",
        "static/img/background/background-4.jpg",
        "static/img/background/background-5.jpg",
      ];
      var shuffled = images[Math.floor(Math.random() * images.length)];
      if (!this.shuffledImage) {
        this.shuffledImage = "'" + shuffled + "'";
      }
    },
  },
  beforeDestroy() {
    this.closeMenu();
  },
  computed: {
    ws: () => {
      return Webservice;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/PasswordForgot.vue